import { formatarDecimal } from "../../lib/formato/decimal";
import type { SaldoBloco } from "../../lib/dashboard/tipos";

/*
 * Cards de saldo do dashboard (Tela 1). Três cards lado a lado (grid responsivo):
 *  1. Saldo hoje — o BALANÇO de D+0 (`saldo.hoje.saldo`). Cor por sinal: começa
 *     com "-" → `text-erro` (negativo), senão `text-sucesso`.
 *  2. Próximos 7 dias — `saldo.projecao_7d.saldo_projetado` + entradas/saídas.
 *  3. Próximos {horizonte} dias — `saldo.projecao_horizonte.saldo_projetado` +
 *     entradas/saídas (rótulo do horizonte é DINÂMICO).
 *
 * Money é SEMPRE `formatarDecimal` (string-based, sem "R$", nunca `Number`).
 * Só tokens CPMH; nenhum hex/px literal.
 */

interface SaldoCardsProps {
  saldo: SaldoBloco;
  horizonte: number;
}

/** `text-erro` se o valor monetário começa com "-" (negativo), senão `text-sucesso`. */
function corSaldo(valor: string): string {
  return valor.startsWith("-") ? "text-erro" : "text-sucesso";
}

export function SaldoCards({ saldo, horizonte }: SaldoCardsProps): JSX.Element {
  return (
    <div className="grid gap-4 md:grid-cols-3">
      <div className="rounded-lg border border-platinum bg-snow p-4">
        <h2 className="font-subtitulo text-base text-off-black">Saldo hoje</h2>
        <p className={`font-titulo text-2xl ${corSaldo(saldo.hoje.saldo)}`}>
          {formatarDecimal(saldo.hoje.saldo)}
        </p>
        <p className="font-corpo text-sm text-off-black">
          Entradas {formatarDecimal(saldo.hoje.entradas)} · Saídas{" "}
          {formatarDecimal(saldo.hoje.saidas)}
        </p>
      </div>

      <div className="rounded-lg border border-platinum bg-snow p-4">
        <h2 className="font-subtitulo text-base text-off-black">
          Próximos 7 dias
        </h2>
        <p
          className={`font-titulo text-2xl ${corSaldo(
            saldo.projecao_7d.saldo_projetado,
          )}`}
        >
          {formatarDecimal(saldo.projecao_7d.saldo_projetado)}
        </p>
        <p className="font-corpo text-sm text-off-black">
          Entradas {formatarDecimal(saldo.projecao_7d.entradas)} · Saídas{" "}
          {formatarDecimal(saldo.projecao_7d.saidas)}
        </p>
      </div>

      <div className="rounded-lg border border-platinum bg-snow p-4">
        <h2 className="font-subtitulo text-base text-off-black">
          Próximos {horizonte} dias
        </h2>
        <p
          className={`font-titulo text-2xl ${corSaldo(
            saldo.projecao_horizonte.saldo_projetado,
          )}`}
        >
          {formatarDecimal(saldo.projecao_horizonte.saldo_projetado)}
        </p>
        <p className="font-corpo text-sm text-off-black">
          Entradas {formatarDecimal(saldo.projecao_horizonte.entradas)} · Saídas{" "}
          {formatarDecimal(saldo.projecao_horizonte.saidas)}
        </p>
      </div>
    </div>
  );
}
